import { Directive, ElementRef, AfterViewInit, OnInit, OnDestroy, Input, Output } from '@angular/core';
import { Utility } from '../_service/utility';
import { WindowScrollService } from '../_service/window.scroll.service';

@Directive({
    selector: '[lazyLoad]',
})
export class LazyLoadDirective implements AfterViewInit, OnDestroy {
    //private imageSrc = "";
    private index = -1;
    static lastRect = {
        width: 0,
        height: 0,
        bottom: 0,
        left: 0,
        right: 0,
        top: 0,
        x: 0,
        y: 0
    };
    @Input() dataSrc = "";
    constructor(private elementRef: ElementRef,
        private scroll: WindowScrollService,
        private _utility:Utility
    ) {

    }
    private timeout = null;

    ngOnDestroy(): void {
        this.scroll.removeIndex(this.index);
        clearTimeout(this.timeout);

    }
    ngAfterViewInit(): void {
        this.timeout = setTimeout(() => {
            var el = this.elementRef.nativeElement as HTMLImageElement;
            var rect = el.getBoundingClientRect();
            if (rect.width == 0 && rect.height == 0) {
                rect = LazyLoadDirective.lastRect as DOMRect;
            }
            else {
                LazyLoadDirective.lastRect = rect;
            }
            let posY =  (rect.y || rect.top) ;
            let scrollY = this._utility.getWindow().innerHeight + this._utility.getWindow().scrollY;

           // console.log("lazy module",scrollY,posY,rect)
            if (scrollY > posY) {
                el.src = this.dataSrc;
            }
            else {
                this.index = this.scroll.addPlaceHolder(posY - scrollY, () => {
                    el.src = this.dataSrc;
                    this.index = -1;
                })
            }
        }, 20);
    }

}